<div role="main" class="main">

  <section class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <ul class="breadcrumb">
            <li><a href="#">Anasayfa</a></li>
            <li class="active">Kariyer</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h1>Kariyer</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container">

    <h2><strong>Intes Technology</strong>'de Çalışmak!</h2>

    <div class="row">
      <div class="col-md-12">
        <p class="lead">
          İşe alımlarımızda, Intes Technology kurum kültürüne ve pozisyona özel yetkinliklere sahip en uygun adayı Intes Technology'e kazandırmayı hedefleriz. Şirketimize yapılan tüm başvurular kaydedilir. Açık pozisyonlar için gerekli niteliklere uyan adaylardan bir havuz oluşturulur ve işe alım süreci başlatılır.
        </p>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-md-8">
        <div class="toggle toggle-primary mt-lg" data-plugin-toggle>
          <section class="toggle" style="font-size: 14pt !important;">
            <label>Swift Yazılım Uzmanı</label>
            <div class="toggle-content" style="font-size: 13pt !important;">
                        <ul>
                           <li>Swift programlama diline hakim</li>
                           <li>UI/UX tecrübesi olan</li>
                           <li>Web servisleri/REST API'leri hakkında bilgi sahibi ve çalışma deneyimli</li>
                           <li>Mobil uygulama geliştirme konusunda yeni teknolojileri takip eden</li>
                           <li>Alanında en az 2 yıl deneyim sahibi takım arkadaşı aramaktayız.</li>
                        </ul>

              <p><a class="btn btn-primary mb-xl" href="mailto:info@intestech.com.tr?subject=Intes Technology İş Başvurusu">Şimdi Başvur</a></p>
            </div>
          </section>
          <section class="toggle" style="font-size: 14pt !important;">
            <label>Android Yazılım Uzmanı</label>
            <div class="toggle-content" style="font-size: 13pt !important;">
                        <ul>
                           <li>Native Android uygulama geliştirme konularında tecrübeye sahip</li>
                           <li>Web servisleri/REST API'leri hakkında bilgi sahibi ve çalışma deneyimi olan</li>
                           <li>Mobil uygulama geliştirme konusunda yeni teknolojileri takip eden</li>
                           <li>Alanında en az 2 yıl deneyim sahibi takım arkadaşı aramaktayız.</li>
                        </ul>

              <p><a class="btn btn-primary mb-xl" href="mailto:info@intestech.com.tr?subject=Intes Technology İş Başvurusu">Şimdi Başvur</a></p>
            </div>
          </section>
          <section class="toggle" style="font-size: 14pt !important;">
            <label>Web Yazılım Uzmanı(C#)</label>
            <div class="toggle-content" style="font-size: 13pt !important;">
                        <ul>
                           <li>C# .NET platformunda web tabanlı projelerde tecrübeli</li>
                           <li>Microsoft SQL Server veritabanı ve Sql programlama dili konusunda tecrübeli</li>
                           <li>ASP.Net MVC, C#, iyi derecede bilgi sahibi</li>
                           <li>Alanında en az 2 yıl deneyim sahibi</li>
                           <li>Tercihen React bilen takım arkadaşı aramaktayız.</li>
                        </ul>

              <p><a class="btn btn-primary mb-xl" href="mailto:info@intestech.com.tr?subject=Intes Technology İş Başvurusu">Şimdi Başvur</a></p>
            </div>
          </section>
          <section class="toggle" style="font-size: 14pt !important;">
            <label>Web Yazılım Uzmanı(.Net Core)</label>
            <div class="toggle-content" style="font-size: 13pt !important;">
                        <ul>
                           <li>NET Core ile web tabanlı projelerde tecrübeli</li>
                           <li>Microsoft SQL Server veritabanı ve Sql programlama dili konusunda tecrübeli</li>
                           <li>Web Servisleri/REST Api hakkında iyi derecede bilgi sahibi</li>
                           <li>Alanında en az 2 yıl deneyim sahibi</li>
                           <li>Tercihen React bilen takım arkadaşı aramaktayız.</li>
                        </ul>

              <p><a class="btn btn-primary mb-xl" href="mailto:info@intestech.com.tr?subject=Intes Technology İş Başvurusu">Şimdi Başvur</a></p>
            </div>
          </section>
          <section class="toggle" style="font-size: 14pt !important;">
            <label>Arayüz Tasarımcısı</label>
            <div class="toggle-content" style="font-size: 13pt !important;">
                        <ul>
                           <li>Mobil ve web tasarım konusunda en az 1-2 yıl tecrübeli</li>
                           <li>Responsive arayüz tasarımına hakim</li>
                           <li>Takım çalışmasına yatkın</li>
                           <li>İletişimi güçlü</li>
                           <li>Müşteri ve sonuç odaklı çalışabilecek olan takım arkadaşı aramaktayız.</li>
                        </ul>

              <p><a class="btn btn-primary mb-xl" href="mailto:info@intestech.com.tr?subject=Intes Technology İş Başvurusu">Şimdi Başvur</a></p>
            </div>
          </section>
                  <section class="toggle" style="font-size: 14pt !important;">
                     <label>Satış ve Müşteri İlişkileri Yöneticisi</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">
                        <ul>
                           <li>Satış teknikleri konusunda bilgi sahibi.</li>
                           <li>Müşteri yönetimini yapabilecek (Satış, proje sürecinde müşteri ilişkileri, tahsilat takibi)</li>
                           <li>Teknolojiye meraklı ve yatkın (Yazılım süreçleri hakkında detaylı eğitim verilecektir)</li>
                           <li>İletişimi güçlü</li>
                           <li>Müşteri ve sonuç odaklı çalışabilecek</li>
                           <li>Yazılım ürünlerini satabilecek</li>
                           <li>Müşteriye özel geliştirilecek olan yazılım satışında teknik öncesi (Teknik değerlendirme ve tekliflendirme kriterlerinin belirlemesi teknik ekibimiz tarafından yapılmaktadır) ilişkileri kuracak takım arkadaşı aramaktayız.</li>
                        </ul>

                        <p><a class="btn btn-primary mb-xl" href="mailto:info@intestech.com.tr?subject=Intes Technology İş Başvurusu">Şimdi Başvur</a></p>
                     </div>
                  </section>
          <section class="toggle" style="font-size: 14pt !important;">
            <label>Kendi Rolünüz</label>
            <div class="toggle-content" style="font-size: 13pt !important;">
                        <ul>

                        </ul>
              <p>İlgilendiniz ama bizim iş tanımlarından birine mükemmel bir uyum bulamadınız mı?
                        <br><br>Mobil/Web uygulamaları için bir tutkun varsa, lütfen bize ulaşın ve biz sizin için bir rol bulup bulamayacağıma bakalım.</p>
              <p><a class="btn btn-primary mb-xl" href="mailto:info@intestech.com.tr?subject=Intes Technology İş Başvurusu">Şimdi Başvur</a></p>
            </div>
          </section>
        </div>
      </div>
      <div class="col-md-4">
        <div class="featured-box featured-box-primary">
          <div class="box-content" style="font-size: 14pt !important;">
            <h4 class="text-uppercase">Genel Nitelikler</h4>


            <hr>

            <ul class="list list-icons align-left" style="font-size: 13pt !important;">
              <li><i class="fa fa-check"></i>İnsan İlişkilerinde Başarılı</li>
                        <li><i class="fa fa-check"></i>Çözüm odaklı</li>
                        <li><i class="fa fa-check"></i>Sorumluluk sahibi</li>
                        <li><i class="fa fa-check"></i>Anlayışlı ve samimi</li>
              <li><i class="fa fa-check"></i>Özgüveni Yüksek ve Açık Fikirli</li>
              <li><i class="fa fa-check"></i>Askerlikle İlişkisi Olmayan</li>
              <li><i class="fa fa-check"></i>Konumdan bağımsız</li>
            </ul>

          </div>
        </div>
      </div>
    </div>

  </div>

</div>
